import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { AvatarPrimitive } from '../../../models/app/avatar-primitive';
import { ChipSelectorComponent } from '../chip-selector/chip-selector.component';
import { SearchRequest } from '../../../models/data/app-core/search-request';
import { ComponentDialogResult } from '../../../models/app/component-dialog-result';
import { SearchRequestBase } from '../../../models/net/request/base/search-request-base';
import { TypeFactory } from '../../../utilities/type-factory';
import { SearchRequestEnvelope } from '../../../models/net/envelope/search-request-envelope';
import { SearchRequestDocument } from '../../../models/net/envelope/documents/search-request-document';
import { SearchRequestService } from '../../../services/search-requests/search-request.service';
import { SearchRequestType } from '../../../models/data/app-core/search-request-type';
import { SearchRequestSearchRequest } from '../../../models/net/request/search-request-search-request';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { SearchRequestTypeEnum } from '../../../enums/search-request-type-enum';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { isSubscription } from 'rxjs/internal/Subscription';
import { SearchRequestSearchResult } from '../../../models/net/result/search-request-search-result';
import { SearchPreferencesTileComponent } from '../search-preferences-tile/search-preferences-tile.component';
import { PersonEnvelope } from '../../../models/net/envelope/person-envelope';
import { SessionDocument } from '../../../models/net/envelope/documents/session-document';
import { SearchPreference } from '../../../models/data/app-core/search-preference';
import { SessionEnvelope } from '../../../models/net/envelope/session-envelope';
import { SessionService } from '../../../services/session/session.service';
import { UpdateResult } from '../../../models/net/result/crud/update-result';

@Component({
    selector: 'app-search-marquee',
    templateUrl: './search-marquee.component.html',
    styleUrls: ['./search-marquee.component.css', '../../../app.component.css']
})

export class SearchMarqueeComponent implements OnInit {

    public isSavedSearchMode: boolean = false;
    public availableSearchRequests: AvatarPrimitive[] = [];
    public selectedSearchRequestIds: number[] = [];
    public selectedSearchRequests: AvatarPrimitive[] = [];
    public acceptButtonCaption: string = "RUN SEARCH";
    public defaultSearchRequestEnvelope: SearchRequestEnvelope | undefined;
    public savedSearchTemplateEnvelope: SearchRequestEnvelope | undefined;
    public defaultSearchRequest: any = new SearchRequestBase();
    public searchRequestEnvelopes: SearchRequestEnvelope[] = [];
    public dialogTitle: string = "Search Editor";
    public searchTypeToggleCaption = "BASIC";
    private adhocSearchRequestEnvelopeItemId: number = -100000;

    @ViewChild("searchRequestSelector") searchRequestSelector!: ChipSelectorComponent;

    @Input() public searchRequestTypeEnum: SearchRequestTypeEnum | undefined;
    @Input() public searchRequestTileComponentTypeName: string = "";
    @Input() public disabled: boolean = false; // true;

    @Output() public runSearch = new EventEmitter<SearchRequestEnvelope>();
    @Output() public runSavedSearch = new EventEmitter<SearchRequestEnvelope>();
    @Output() public saveSearch = new EventEmitter<SearchRequestEnvelope>();

    public constructor(public appService: AppService, public sessionService: SessionService, public searchRequestService: SearchRequestService) { }

    public ngOnInit(): void { // need two things - a default search request and a list of saved search requests for the given searchtype

        this.initializeSearchMarquee();
    }

    public initializeSearchMarquee = (): Observable<boolean | null> => {

        let result: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

        const searchRequestSearchRequest: SearchRequestSearchRequest = new SearchRequestSearchRequest();
        const searchRequestTypes: SearchRequestType[] = TypeFactory.convertSearchRequesTypeEnumToTypeArray();

        searchRequestSearchRequest.BasicSearchString.IsWildPrefix = true;
        searchRequestSearchRequest.BasicSearchString.IsWildSuffix = true;
        searchRequestSearchRequest.BasicSearchString.IsWildPrefix = true;
        searchRequestSearchRequest.BasicSearchString.IsWildSuffix = true;
        searchRequestSearchRequest.SearchRequestTypeIds.push(this.searchRequestTypeEnum as number);
        searchRequestSearchRequest.IsAdvancedSearch = true; // this forces the basic search to look only at the search request types as this is what is of interest

        this.appService.IsAppBusy = true;

        this.searchRequestService.GetNewEnvelopeBySearchRequestTypeNameAsync(SearchRequestTypeEnum[this.searchRequestTypeEnum!], false).subscribe((searchRequestEnvelope: any | null) => {

            if (searchRequestEnvelope) {

                //const searchRequestJson: string = searchRequestEnvelope?.Document?.Item.SearchRequestJson;
                this.defaultSearchRequestEnvelope = searchRequestEnvelope;
                this.defaultSearchRequest = TypeFactory.getGetTypedSearchRequestFromSearchRequestEnvelope(this.defaultSearchRequestEnvelope as SearchRequestEnvelope, this.searchRequestTypeEnum!);

                let savedSearchTemplateIsAdvancedByDefault: boolean = false;

                try {

                    const defaultSearchRequestSearchRequest: SearchRequestSearchRequest = JSON.parse(this.defaultSearchRequestEnvelope!.Document!.Item.SearchRequestJson);
                    savedSearchTemplateIsAdvancedByDefault = defaultSearchRequestSearchRequest.IsAdvancedSearchCapable;

                } catch { }

                this.searchRequestService.GetNewEnvelopeBySearchRequestTypeNameAsync(SearchRequestTypeEnum[this.searchRequestTypeEnum!], savedSearchTemplateIsAdvancedByDefault).subscribe((savedSearchRequestEnvelope: any | null) => {

                    if (savedSearchRequestEnvelope) {

                        // set advanced search template envelope to be used for ad-hoc advanced searches 
                        this.savedSearchTemplateEnvelope = savedSearchRequestEnvelope;

                        this.searchRequestService.search(searchRequestSearchRequest).subscribe((r: SearchRequestSearchResult[] | null) => { // get saved searches

                            if (r) {

                                const searchRequestEnvelopes = r.map((i: SearchRequestSearchResult) => {

                                    let result: SearchRequestEnvelope = new SearchRequestEnvelope(null);
                                    
                                    const filteredSearchRequestTypes: SearchRequestType[] = searchRequestTypes.filter((searchRequestType: SearchRequestType) => searchRequestType.UID == i.SearchRequestType)

                                    if (filteredSearchRequestTypes && filteredSearchRequestTypes.length == 1) {

                                        result.SearchRequestTypes = searchRequestTypes;
                                        result.Document = new SearchRequestDocument();
                                        result.Document.Item = new SearchRequest();
                                        result.Document.Item.Name = i.Name;
                                        result.Document.Item.Description = i.Description;
                                        result.Document.Item.SearchRequestId = i.SearchRequestId;
                                        result.Document.Item.SearchRequestJson = i.SearchRequestJson;
                                        result.Document.Item.SearchRequestTypeId = filteredSearchRequestTypes[0].SearchRequestTypeId;
                                    }

                                    return result;
                                });

                                this.searchRequestEnvelopes = searchRequestEnvelopes;

                                if (this.searchRequestEnvelopes.length > 0) {

                                    // tranform to avatarprimitive for the chip selector
                                    this.availableSearchRequests = this.searchRequestEnvelopes.map((i: SearchRequestEnvelope) => {
                                        let result = new AvatarPrimitive();
                                        result.Id = i.Document.Item.SearchRequestId;
                                        result.Name = i.Document.Item.Name;
                                        result.AvatarBlobPath = this.appService.defaultImageUri;
                                        result.IsDefault = false;
                                        result.IsEditable = true;
                                        return result;
                                    });
                                }

                                this.appService.IsAppBusy = false;

                                result.next(true);
                                result.complete();
                            }
                        });
                    }
                });
            }
        });

        return result;
    }

    public ngAfterViewInit(): void {

        this.searchRequestSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedSearchRequests[0] = item;
            this.selectedSearchRequestIds[0] = item.Id;
            this.searchRequested();
        });

        this.searchRequestSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedSearchRequests = [];
            this.selectedSearchRequestIds = [];
        });

        this.searchRequestSelector.itemClicked.subscribe((itemId: number) => {

            var selectedSearchRequestEnvelopes: SearchRequestEnvelope[] = this.searchRequestEnvelopes.filter((i: SearchRequestEnvelope) => i.Document.Item.SearchRequestId == this.selectedSearchRequestIds[0]);

            if (selectedSearchRequestEnvelopes && selectedSearchRequestEnvelopes.length == 1) {

                this.showAdvancedSearchDialog(selectedSearchRequestEnvelopes[0]);
            }
        });
    }

    public ngOnChanges(changes: SimpleChanges) {

        if (changes["searchRequestEnvelopes"]) {

            if (this.searchRequestEnvelopes.length > 0) {

                // tranform to avatarprimitive for the chip selector
                this.availableSearchRequests = this.searchRequestEnvelopes.map((i: SearchRequestEnvelope) => {
                    let result = new AvatarPrimitive();
                    result.Id = i.Document.Item.SearchRequestId;
                    result.Name = i.Document.Item.Name;
                    result.AvatarBlobPath = this.appService.defaultImageUri;
                    return result;
                });

            } else {

                this.availableSearchRequests = [];
            }
        }
    }

    public searchRequested = (): void => {

        if (this.isSavedSearchMode) {

            if (this.selectedSearchRequestIds.length == 0) { // user has not selected a saved search, show the dialog for add-hoc comprehensive search
            //if (this.selectedSearchRequests.length == 0) {

                this.showAdvancedSearchDialog(null);

            } else { // user selected an existing search request, find it and run it

                var selectedSearchRequestEnvelopes = this.searchRequestEnvelopes.filter((i: SearchRequestEnvelope) => i.ItemId == this.selectedSearchRequestIds[0]);

                if (selectedSearchRequestEnvelopes && selectedSearchRequestEnvelopes.length == 1) {

                    this.selectedSearchRequests = this.availableSearchRequests.filter((i: AvatarPrimitive) => i.Id == this.selectedSearchRequestIds[0]);

                    this.runSavedSearch.emit(selectedSearchRequestEnvelopes[0]);
                }
            }

        } else { // user is just typing into the basic fields 

            this.defaultSearchRequestEnvelope!.Document!.Item.SearchRequestJson = JSON.stringify(this.defaultSearchRequest);
            this.runSavedSearch.emit(this.defaultSearchRequestEnvelope);
        }
    }

    public showAdvancedSearchDialog = (searchRequestEnvelope: SearchRequestEnvelope | null): void => {

        if (!searchRequestEnvelope) {

            searchRequestEnvelope = this.appService.cloneObject(this.savedSearchTemplateEnvelope);
            searchRequestEnvelope!.Document!.Item.Name = "(New saved search - click to set name)";
            searchRequestEnvelope!.Document!.Item.Description = "(New saved search description - click here to set description)";
        }

        //searchRequestEnvelope!.SearchRequestTypes = TypeFactory.convertSearchRequesTypeEnumToTypeArray();
        //searchRequestEnvelope!.Document!.Item.SearchRequestJson = JSON.stringify(this.searchRequest);

        let searchRequestTileComponentType: any = TypeFactory.resolveType(this.searchRequestTileComponentTypeName);

        const materialIconName: string = "frame_inspect";

        this.appService.showComponentDialog(searchRequestTileComponentType,
                                            searchRequestEnvelope,
                                            searchRequestEnvelope!.Document!.Item.Name,
                                            searchRequestEnvelope!.Document!.Item.Description ?? "(Description for " + searchRequestEnvelope!.Document!.Item.Name + ")",
                                            materialIconName,
                                            "SEARCH",
                                            "CANCEL AND CLOSE",
                                            true).subscribe((dialogResult: ComponentDialogResult | null) => {

            if (dialogResult) {

                if (dialogResult.IsAccepted && !dialogResult.IsDataSourceAltered) {

                    this.runSearch.emit(dialogResult.DataSource);

                } else if (dialogResult.IsAccepted && dialogResult.IsDataSourceAltered) { // refresh then search

                    this.initializeSearchMarquee().subscribe((isInitialized: boolean | null) => {

                        this.runSearch.emit(dialogResult.DataSource);
                    });

                } else if (dialogResult.IsDataSourceAltered && !dialogResult.IsAccepted) { // user saved (or deleted) a search request and just closed the dialog

                    this.initializeSearchMarquee();
                }
            }
        });
    }

    public setSearchMode = (isSavedSearchMode: boolean): void => {

        this.isSavedSearchMode = isSavedSearchMode;
    }

    public onToggleChange(event: MatSlideToggleChange) {

        this.isSavedSearchMode = event.checked;

        this.searchTypeToggleCaption = this.isSavedSearchMode ? "ADVANCED" : "BASIC";
    }

    public toggleSearchMode = (): void => {

        this.isSavedSearchMode = !this.isSavedSearchMode;
    }

    public setCurrentSearchAsDefault = (): void => {

        if (this.defaultSearchRequestEnvelope) { // this is needed to determine what the current searchrequesttypeid is which should really be a property of the component

            const searchRequestTypeId: number = this.defaultSearchRequestEnvelope.Document.Item.SearchRequestTypeId;
            const sessionJson: string | null = this.appService.getUserSession();

            if (sessionJson) {

                let sessionDocument: SessionDocument = JSON.parse(sessionJson).serverSession;
                let searchPreference: SearchPreference | undefined = sessionDocument.SearchPreferences.find((i: SearchPreference) => i.SearchRequestTypeId == searchRequestTypeId);

                if (searchPreference) {

                    const defaultSearchRequestId: number = this.selectedSearchRequestIds[0];

                    searchPreference.DefaultSearchRequestId = defaultSearchRequestId;

                    let sessionEnvelope: SessionEnvelope = new SessionEnvelope(null);

                    sessionEnvelope.Document = sessionDocument;

                    this.sessionService.update(sessionEnvelope).subscribe((r: UpdateResult | null) => {

                        if (r) {

                            if (r.IsSuccess) {

                                this.selectedSearchRequestIds = [defaultSearchRequestId];
                                this.setDefaultSearchRequestId(defaultSearchRequestId);

                            } else {

                                //
                            }
                        }
                    });
                }
            }
        }
    }

    public setDefaultSearchRequestId = (defaultSearchRequestId: number): void => {

        this.selectedSearchRequestIds = [defaultSearchRequestId];

        const currentSearchRequestId: number = this.selectedSearchRequestIds[0]; // this.selectedSearchRequests[0].Id;

        this.availableSearchRequests.forEach((i: AvatarPrimitive) => {

            if (i.Id == currentSearchRequestId) {

                i.IsDefault = true;

            } else {

                i.IsDefault = false;
            }
        });
    }

    public newSavedSearch = (): void => {

        //this.showAdvancedSearchDialog(newSearchRequestEnvelope);

        var selectedSearchRequestEnvelopes: SearchRequestEnvelope[] = this.searchRequestEnvelopes.filter((i: SearchRequestEnvelope) => i.Document.Item.SearchRequestId == this.selectedSearchRequestIds[0]);

        if (selectedSearchRequestEnvelopes && selectedSearchRequestEnvelopes.length == 1) {

            let newSearchRequestEnvelope: SearchRequestEnvelope = JSON.parse(JSON.stringify(selectedSearchRequestEnvelopes[0])) as SearchRequestEnvelope;

            newSearchRequestEnvelope.Document.Item.SearchRequestId = -1;
            newSearchRequestEnvelope.Document.Item.Name = "(Enter a name)";
            newSearchRequestEnvelope.Document.Item.Description = "(Enter a description)";
            newSearchRequestEnvelope.Document.Item.SearchRequestJson = JSON.stringify(this.defaultSearchRequest);

            this.showAdvancedSearchDialog(newSearchRequestEnvelope);
        }
    }

    //public showSettings = (): void => {

    //    const personEnvelope: PersonEnvelope = new PersonEnvelope(null);
    //    const dialogTitle: string = "{FirstName} {LastName} - {SearchRequestType} - Preferences";
    //    const materialIconName: string = "settings";

    //    this.appService.showComponentDialog(SearchPreferencesTileComponent, personEnvelope, dialogTitle, "Set search preferences for {SearchRequestType}", materialIconName, undefined, undefined, false).subscribe((r: ComponentDialogResult | null) => {

    //        if (r) {

    //            if (r.IsAccepted) { // this means the user made a change and hit ok.  put the changes back into the item envelope 

    //                this.appService.showPendingFeatureDialog();
    //            }
    //        }
    //    });
    //}
}
